import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=bfd6a002&scoped=true"
import script from "./MyTeam.vue?vue&type=script&lang=js"
export * from "./MyTeam.vue?vue&type=script&lang=js"
import style0 from "./MyTeam.vue?vue&type=style&index=0&id=bfd6a002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6a002",
  null
  
)

export default component.exports